/**
 * Canonical registry of Supabase Storage bucket names used by the app.
 *
 * Every client-side `supabase.storage.from(...)` call should resolve its
 * bucket ID through this module — never inline a string literal. That keeps
 * a whitelabel fork's rename to `${tenant}-listing-images` a one-file edit
 * (this file + optionally `PLATFORM_CONFIG.storageBucketPrefix`) instead of
 * a repo-wide sweep. See docs/FORK_GUIDE.md §Storage.
 *
 * Canonical CardSimp uses no prefix — the constants below evaluate to the
 * exact bucket IDs that already exist in the project.
 */
import { PLATFORM_CONFIG } from '@/lib/platformConfig';

const prefix = PLATFORM_CONFIG.storageBucketPrefix ?? '';

const b = (name: string) => `${prefix}${name}`;

export const STORAGE_BUCKETS = {
	avatars: b('avatars'),
	listingImages: b('listing-images'),
	chatAttachments: b('chat-attachments'),
	inquiryAttachments: b('inquiry-attachments'),
	contactAttachments: b('contact-attachments'),
	menuExports: b('menu-exports'),
	idVerification: b('id-verification'),
} as const;

export type StorageBucketKey = keyof typeof STORAGE_BUCKETS;
